import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'right',
        flexWrap: 'wrap',
    },
    chip: {
        cursor: 'pointer',
        margin: theme.spacing.unit,
    },
});

function Chips(props) {
    const {classes, keywords, removeKeyWord, selectKeyWord} = props;
    return (
        <div className={classes.root}>
            {keywords.map((keyword, index) => (
                <Chip key={index}
                      color={keyword.selected ? "primary" : "default"}
                      label={keyword.name}
                      onClick={() => selectKeyWord(keyword.name)}
                      onDelete={() => removeKeyWord(keyword.name)}
                      className={classes.chip}
                />))}
        </div>
    );
}

Chips.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Chips);
